import { invokeRPC } from './socket.js'

export function createSavedReport(data) {
  return invokeRPC('savedReport', 'createSavedReport', data)
}

export function getReportList(data) {
  return invokeRPC('savedReport', 'getReportList', data)
}

export function deleteReport(data) {
  return invokeRPC('savedReport', 'deleteReport', data)
}

// Renamed from getReport to avoid naming conflicts with other modules.
export function getSavedReport(id) {
  return invokeRPC('savedReport', 'getReport', { id })
}

export function updateReport(data) {
  return invokeRPC('savedReport', 'updateReport', data)
}

export function projectHasReports(projectId) {
  return invokeRPC('savedReport', 'projectHasReports', { project_id: projectId })
}